import { render, staticRenderFns } from "./OnlineBiddingDetail.vue?vue&type=template&id=a2b52a0a&scoped=true&"
import script from "./OnlineBiddingDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineBiddingDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBiddingDetail.vue?vue&type=style&index=0&id=a2b52a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b52a0a",
  null
  
)

export default component.exports